/**
 * @generated SignedSource<<860de0499774f7ea2d362f3dc8b62b0e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type FunnelUserTagModuleList_Query$variables = {
  siteSlug: string;
  funnelIds?: ReadonlyArray<string> | null;
  pageIds?: ReadonlyArray<string> | null;
};
export type FunnelUserTagModuleList_QueryVariables = FunnelUserTagModuleList_Query$variables;
export type FunnelUserTagModuleList_Query$data = {
  readonly site: {
    readonly userTagModules: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
      readonly effectiveEnabled: boolean;
      readonly hasPendingToggle: boolean;
      readonly publishedAt: string | null;
      readonly createdAt: string;
      readonly popupGroups: ReadonlyArray<{
        readonly id: string;
        readonly name: string;
        readonly slug: string;
        readonly page: {
          readonly id: string;
        };
      }>;
      readonly abtestScenarioPageGroups: ReadonlyArray<{
        readonly id: string;
        readonly title: string;
        readonly slug: string;
        readonly page: {
          readonly id: string;
        };
      }>;
    }>;
  };
};
export type FunnelUserTagModuleList_QueryResponse = FunnelUserTagModuleList_Query$data;
export type FunnelUserTagModuleList_Query = {
  variables: FunnelUserTagModuleList_QueryVariables;
  response: FunnelUserTagModuleList_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "funnelIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageIds"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "siteSlug"
},
v3 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "siteSlug"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Page",
  "kind": "LinkedField",
  "name": "page",
  "plural": false,
  "selections": [
    (v4/*: any*/)
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "funnelIds",
      "variableName": "funnelIds"
    },
    {
      "kind": "Variable",
      "name": "pageIds",
      "variableName": "pageIds"
    }
  ],
  "concreteType": "UserTagModule",
  "kind": "LinkedField",
  "name": "userTagModules",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "effectiveEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasPendingToggle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publishedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PopupGroup",
      "kind": "LinkedField",
      "name": "popupGroups",
      "plural": true,
      "selections": [
        (v4/*: any*/),
        (v5/*: any*/),
        (v6/*: any*/),
        (v7/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AbtestScenarioPageGroup",
      "kind": "LinkedField",
      "name": "abtestScenarioPageGroups",
      "plural": true,
      "selections": [
        (v4/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        (v6/*: any*/),
        (v7/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "FunnelUserTagModuleList_Query",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Site",
        "kind": "LinkedField",
        "name": "site",
        "plural": false,
        "selections": [
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "FunnelUserTagModuleList_Query",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Site",
        "kind": "LinkedField",
        "name": "site",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7498f45d996fc12be96b1750a788fba7",
    "id": null,
    "metadata": {},
    "name": "FunnelUserTagModuleList_Query",
    "operationKind": "query",
    "text": "query FunnelUserTagModuleList_Query(\n  $siteSlug: String!\n  $funnelIds: [ID!]\n  $pageIds: [ID!]\n) {\n  site(slug: $siteSlug) {\n    userTagModules(funnelIds: $funnelIds, pageIds: $pageIds) {\n      id\n      name\n      effectiveEnabled\n      hasPendingToggle\n      publishedAt\n      createdAt\n      popupGroups {\n        id\n        name\n        slug\n        page {\n          id\n        }\n      }\n      abtestScenarioPageGroups {\n        id\n        title\n        slug\n        page {\n          id\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "f9897b610b80ee4fb353929433428da8";

export default node;
